import React, { useEffect } from 'react';
import ModalPane from '../ModalPane/ModalPane';
import DataAPI from '../../../Utils/Api';
import TextField from '../TextField/TextField';
import { ThumbRating } from '../Ratings/Ratings';
import {
	T,
	TString,
} from '../../../../src/Components/FeatureComponents/Response/Utils';
import styled from 'styled-components';
import Input from '../../../../src/Components/FlyfishComponents/Input';

interface Props {
	selectedRating;
	msgKey;
	data;
	popUpSnackBar;
	messageFeedbackCallback;
	messageFeedbackPrevVal;
	submitFeedback;
	thumbFilledUp;
	thumbFilledDown;
	messageId;
	colorMode: string;
	openThumbsPopup;
}
const FEEDBACKCOMMENT = styled.div`
	&.ff-message-feedback-wrapper {
		& .custom-button {
			& > button {
				background-color: ${(props) => {
					return props.colorMode === 'dark'
						? 'var(--selectedColor)'
						: 'var(--colorScale-2)';
				}} !important;
				& > .custom-button-body {
					color: ${(props) => {
						return props.colorMode === 'dark'
							? '#ffffff'
							: 'var(--colorScale-9)';
					}} !important;
				}
			}
		}
		& .MuiInputBase-root {
			&:not(.Mui-disabled, .Mui-error).Mui-focused {
				.MuiOutlinedInput-notchedOutline {
					border-color: ${(props) => {
						return props.colorMode === 'dark'
							? 'var(--selectedColor)'
							: 'var(--colorScale-2)';
					}} !important;
				}
			}
		}
	}
`;
export default function MessageFeedbackComment(props: Props) {
	const [comment, setComment] = React.useState('');
	const [newThumb, setNewThumb] = React.useState('');

	const thanks = TString({ labelName: 'ThanksFeedbackLabel' });
	useEffect(() => {
		setTimeout(() => {
			var el = document.querySelector('.textfield-text');
			el && (el as HTMLElement).focus();
		}, 100);
	});
	function sendFeedbackComment(key, type, comment) {
		DataAPI()
			.get('/saveComment', {
				params: {
					key,
					type,
					comment,
				},
			})
			.then((response) => {
				window['toggleMsgFeed'](props.selectedRating);
				window['popUpSnackBar'](thanks);
			})
			.catch((error) => {
				console.log(error);
			});
	}

	return (
		<FEEDBACKCOMMENT
			colorMode={props.colorMode}
			className='ff-message-feedback-wrapper'
		>
			<ModalPane
				onClose={() => {
					{
						let prevThumbsValue =
							props.messageFeedbackPrevVal === 'Up'
								? true
								: props.messageFeedbackPrevVal === 'Down'
								? false
								: null;
						props.openThumbsPopup(null, null, 0);
						// if (prevThumbsValue === null) {
						// 	props.messageFeedbackCallback(prevThumbsValue);
						// } else {
						// 	props.messageFeedbackCallback(prevThumbsValue, true);
						// }
						// window['toggleMsgFeed'](props.selectedRating);
					}
				}}
				disabled={comment.length > 150 ? true : false}
				buttons={[
					{
						label: <T labelName='submitLabel' />,
						onClick: () => {
							if (newThumb) {
								props.messageFeedbackCallback(
									newThumb === 'Up' ? true : false,
									true
								);
							}
							// if (comment) {
							// sendFeedbackComment(props.msgKey, props.selectedRating, comment);
							props.submitFeedback(
								0,
								comment.replace(/ {2,}/g, ' '),
								props.thumbFilledUp === true ? 4 : 2,
								props.messageId
							);
							// window['toggleMsgFeed'](props.selectedRating);
							// } else {
							//   window['toggleMsgFeed'](props.selectedRating);
							//   window['popUpSnackBar'](thanks);
							// }
						},
						variant: 'filled',
						fullWidth: false,
					},
				]}
			>
				<>
					<ThumbRating
						messageKey={props.msgKey}
						data={props.data}
						size={'large'}
						popUpSnackBar={props.popUpSnackBar}
						noOutlineHover
						centered
						selected={props.thumbFilledUp === true ? 'Up' : 'Down'}
						onClick={setNewThumb}
						isResponselevelFeedback={false}
						messageId={props.messageId}
						openThumbsPopup={props.openThumbsPopup}
						thumbFilledUp={props.thumbFilledUp}
					/>
					{/* <TextField
          placeholder={TString({ labelName: 'addComment' })}
          value={comment}
          onChange={setComment}
          maxChar={1000}
        /> */}
					{/* <input
          type='text'
          id='FeedbackInputBox'
          style={{
            maxHeight: '75px',
            width: '100%',
            padding: '8px 12px 8px 11.8px',
            borderRadius: '8px',
            border: 'solid 2px var(--selectedColor)',
            backgroundColor: "#ffffff",
            marginTop: "10px"
          }}

          placeholder={TString({ labelName: 'addComment' })}
          className='feedback-input'
          autoComplete='off'
          value={comment}
          onChange={(ev) => { setComment(ev.target.value) }}

        ></input> */}
					<Input
						fullWidth
						placeholder={TString({ labelName: 'addComment' })}
						className='feedback-input'
						autoComplete='off'
						value={comment}
						onChange={(ev) => {
							setComment(ev.target.value);
						}}
					/>
					{comment.length > 150 && (
						<div style={{ fontSize: '12px', marginTop: '4px', color: 'red' }}>
							Character limit exceeds. Please limit your input to 150
							characters.
						</div>
					)}
				</>
			</ModalPane>
		</FEEDBACKCOMMENT>
	);
}
